import React, { useState } from "react";
import styled from "styled-components";
import { triangle } from "polished";
import OpenArrow from "./open-indicator";

const HoverMenuStyle = styled.li`
  display: inline-block;
  position: relative;
  padding: 0;
`;

const HoverMenuWrapper = styled.div`
  padding-top: 5px;
  position: absolute;
  left: -75px;
  z-index: 10;
`;

export const HoverMenuContainer = styled.div<{ pointOffset?: number | string }>`
  padding: 0;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transform-style: flat;
  &:before {
    content: "";
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : "")};
    position: absolute;
    top: -4px;
    ${triangle({
      pointingDirection: "top",
      width: "18px",
      height: "9px",
      foregroundColor: "#ddd"
    })};
  }
  &:after {
    content: "";
    ${props => (props.pointOffset ? `left: ${props.pointOffset}` : "")};
    position: absolute;
    top: -3px;
    ${triangle({
      pointingDirection: "top",
      width: "18px",
      height: "9px",
      foregroundColor: "white"
    })};
  }
`;

type Props = {
  menuItem: React.ReactElement;
  pointOffset?: string | number;
  fancyArrow?: boolean;
  style?: React.CSSProperties;
};

const HoverMenu: React.FC<Props> = ({
  menuItem,
  children,
  pointOffset,
  fancyArrow,
  style,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  return (
    <HoverMenuStyle
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={style}
      {...props}
    >
      {menuItem}
      {fancyArrow && <OpenArrow open={open} />}
      <HoverMenuWrapper style={{ display: open ? "block" : "none" }}>
        <HoverMenuContainer
          pointOffset={pointOffset}
          className="dropdown-container"
        >
          {children}
        </HoverMenuContainer>
      </HoverMenuWrapper>
    </HoverMenuStyle>
  );
};

export default HoverMenu;
